import { useJson } from '@/hooks/useJson'

export interface UnlicensedArtist {
  id: number
  name: string
  theme_count: number
  best_rank: number
  avg_rank: number
  themes: Record<string, number>
}

export function useUnlicensedArtists() {
  return useJson<UnlicensedArtist[]>('/api/unlicensed_artists', 'Failed to load artists')
}
